import styled from 'styled-components';

const CreditsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  font-family: Helvetica, Arial, sans-serif;
  // @media (min-width: 1024px) {
  //   height: 150px;
  // }
`;
const CreditsFlex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
const Text = styled.div`
  font-weight: bold;
  font-size: 15px !important;
  color: #4a4a4a;
  line-height: 1.5;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0;

  span {
    width: 15%;
    color: #4a4a4a;
    font-weight: bold;
    font-size: 10px;
  }
  .actual {
    &:after {
      content: '€/mois';
      position: absolute;
      top: 35px;
      line-height: 20px;
      font-size: 14px;
      text-transform: none;
      text-align: left !important;
      right: 12px;
      @media (max-width: 1024px) {
        right: 26px;
      }
    }
  }
  .previous {
    &:after {
      content: '€';
      position: absolute;
      top: 35px;
      line-height: 20px;
      font-size: 14px;
      text-transform: none;
      text-align: left !important;
      right: 10px;
      @media (max-width: 1024px) {
        right: 20px;
      }
    }
  }
  div {
    width: 40%;
    position: relative;
    // overflow: hidden;
    label {
      color: #4a4a4a;
      font-size: 12px;
    }
    input {
      padding: 8px;
      margin-top: 8px;
      width: 89%;
      // width: 100%;
      border: 1px solid #b2b2b2;
      border-radius: 4px !important;
      transition: 0.3s;
      &:focus {
        outline: none;
        border: 1px solid blue;
      }
      @media (max-width: 1024px) {
        width: 94%;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    span {
      width: 100%;
    }
    div {
      width: 100%;
    }
  }
`;
const Subtitle = styled.div`
  font-size: var(--typo-title2-font-size);
  line-height: var(--typo-title2-line-height);
  color: var(--colors-on-background);
  font-family: var(--typo-title1-font-family);
  letter-spacing: var(--typo-title1-letter-spacing);
  font-weight: var(--typo-title1-font-weight);
  @media (min-width: 1024px) {
    font-size: var(--typo-title1-font-size);
    line-height: var(--typo-title1-line-height);
  }
`;
const ProjectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  selected-button {
    max-width: 40px;
    position: relative;
    padding: 0;
    // color: white;
    float: right !important;
  }
  .to-validate {
    div {
      margin-right: 0;
      margin-left: auto;
    }
  }
`;
const ButtonFlex = styled.div`
  display: flex;
  @media (max-width: 1024px) {
    justify-content: center;
  }
  button {
    border: none;
    font-size: 26px;
    height: 32px;
    width: 32px;
    // background-image: url(/rsc/contrib/image/visuels/cetelem/CREDIT/Rachat de credits/rac_situation_sprites.png);
    // backgro  und-position: 1095px -21px;
    display: inline-block !important;
    margin-top: 16px;
    cursor: pointer;
    color: #3a913f;
    background: #e8f5e9;
  }
  .plus {
    margin-left: 32px;
  }
  .minus {
    margin-left: 5px;
    margin-top: 16px;
    margin-right: 32px;
  }
  .value {
    margin-top: 5px;
    line-height: 50px;
    color: #4a4a4a;
    font-size: 50px;
    font-weight: bold;
  }
`;
const SumFlex = styled.div`
  display: flex;
  justify-content: space-between;
  width: 82.5%;
  margin-left: 17.5%;
  margin-bottom: 30px;
  .actual {
    width: 48%;
    background: #e8f5e9;
    align-items: center;
    border-radius: 5px;
    font-weight: bold;
    color: #4a4a4a;
    .value {
      font-size: 16px;
      padding-right: 8px;
      padding-top: 18px;
      padding-bottom: 18px;
      float: right !important;
      vertical-align: middle;
    }
    .text {
      font-size: 10px;
      font-weight: bold;
      color: #4a4a4a;
      padding-left: 8px;
      line-height: 1.5;
      padding-top: 18px;
      width: 45%;
      float: left;
    }
  }
  .restant {
    width: 48%;
    background: #e8f5e9;
    align-items: center;
    border-radius: 5px;
    font-weight: bold;
    color: #4a4a4a;
    .value {
      font-size: 16px;
      padding-right: 8px;
      padding-top: 18px;
      padding-bottom: 18px;
      float: right !important;
      vertical-align: middle;
    }
    .text {
      font-size: 10px;
      font-weight: bold;
      color: #4a4a4a;
      line-height: 1.5;
      padding-left: 8px;
      padding-top: 18px;
      width: 45%;
      float: left;
    }
  }
  @media (max-width: 1024px) {
    flex-direction: row;
    width: 100%;
    margin-left: 0;
    .actual {
      .text {
        font-size: 12px;
        width: 90%;
      }
      .value {
        float: left !important;
        padding-right: auto;
        padding: 8px;
        width: 100%;
      }
    }
    .restant {
      .text {
        font-size: 12px;
        width: 90%;
      }
      .value {
        float: left !important;
        padding-right: auto;
        padding: 8px;
        width: 100%;
      }
    }
  }
`;

interface Props {
  display: boolean;
}

const test = styled.div<Props>`
  display: ${(props) => (props.display ? 'block' : 'none')};
  // display: none;
`;
export default {
  CreditsContainer,
  CreditsFlex,
  Text,
  Container,
  Subtitle,
  ProjectContainer,
  ButtonFlex,
  SumFlex,
  test,
};
